import axios from './axios'

const notificationsApi = {
  async subscribe() {
    const { data } = await axios.post<null>('/notifications/subscribe')
    return data
  }
}

export default notificationsApi